<template>
  <button
    @click="$emit('click')"
    :class="[
      $style.root,
      active ? 'border-primary font-bold' : 'border-transparent text-black-70'
    ]"
    class="relative flex align-center items-center text-sm px-4 h-full rounded-none focus:outline-none border-b-2 hover:bg-gray-10"
  >
    <slot></slot>
    <div :class="$style.focusState"></div>
  </button>
</template>

<script>
export default {
  name: 'AppTab',

  props: {
    active: Boolean
  }
}
</script>

<style lang="postcss" module>
.root:focus .focusState {
  top: 2px;
  left: 2px;
  width: calc(100% - 4px);
  height: calc(100% - 2px);
  outline: 2px solid theme('colors.primary.default');
  @apply absolute pointer-events-none border border-white;
}
</style>
